(ns common.schema.entities.counterparty-diligence.templates.questions.person
  (:require
   [common.country :as country]
   [common.schema.entities.counterparty-diligence.templates.util :as tu]
   [common.schema.entities.counterparty-diligence.templates.validation :as validation]))

(def first-name
  {:field     :person/first-name
   :label     {:en "First name"}
   :data-type :data.type/text-simple})

(def first-names
  {:field     :person/first-names
   :label     {:en "First names"
               :fi "Etunimet"}
   :data-type :data.type/text-simple})

(def first-names-singular-label
  "CapMan relabel of the :person/first-names field: the field keeps its key
   (stored answers stay compatible) but is shown as a singular first name;
   other given names go to :person/middle-names."
  (assoc first-names :label {:en "First name"
                             :fi "Etunimi"}))

(def middle-names
  {:field         :person/middle-names
   :label         {:en "Middle names"
                   :fi "Toiset nimet"}
   :data-type     :data.type/text-simple
   :mandatoriness :mandatory/optional})

(def last-name
  {:field     :person/last-name
   :label     {:en "Last name"}
   :data-type :data.type/text-simple})

(def full-name
  {:field     :person/full-name
   :label     {:en "Full name"}
   :data-type :data.type/text-simple})

(def date-of-birth
  {:field     :person/date-of-birth
   :label     {:en "Date of birth"}
   :data-type :data.type/date})

(def country
  {:field     :person/country
   :label     {:en "Country"}
   :data-type :data.type/keyword
   :options   country/options})

(def place-of-birth-country
  {:field     :person/place-of-birth-country
   :label     {:en "Place of birth - Country"}
   :data-type :data.type/keyword
   :options   country/options})

(def id-number
  {:field     :person/id-number
   :label     {:en "ID number"}
   :data-type :data.type/text-simple})

(def personal-identity-code
  {:field     :person/personal-identity-code
   :label     {:en "Personal identity code"}
   :data-type :data.type/text-simple})

(def street-address
  {:field     :person/street-address
   :label     {:en "Street address"}
   :data-type :data.type/text-multiline})

(def zip-code
  {:field     :person/zip-code
   :label     {:en "Zip code"}
   :data-type :data.type/text-simple})

(def city
  {:field     :person/city
   :label     {:en "City"}
   :data-type :data.type/text-simple})

(def nationality
  {:field     :person/nationality
   :label     {:en "Nationality"}
   :data-type :data.type/keyword
   :options   country/options})

(def national-identification-number
  {:field :person/national-identification-number
   :label {:en "National identification number"}
   :data-type :data.type/text-simple})

(def nationality-row-template
  {:template/schema
   {:nationality
    {:label     {:en "Nationality"
                 :fi "Kansalaisuus"}
     :data-type :data.type/keyword
     :options   country/options}
    :id-number
    {:label     {:en "National ID number"
                 :fi "Henkilötunnus"}
     :data-type :data.type/text-simple}}})

(def nationalities
  {:field          :person/nationalities
   :label          {:en "Nationality"
                    :fi "Kansalaisuus"}
   :data-type      :data.type/vector
   :item-data-type :data.type/map
   :item-template  nationality-row-template
   :editor-type    :editor.type/nationality-list
   :min-items      1
   :min-items-error :validation.error/at-least-one-nationality-and-national-id-required
   ;; Validates the rows resolved with the legacy single nationality +
   ;; national identification number fallback, so processes saved before the
   ;; multi-nationality field are not flagged.
   :validation-fn  (fn [{:keys [data] :as args}]
                     (validation/validate-vector-field
                      args
                      (some-> (tu/nationality-rows data) vec)))})

(def identification-options
  [{:key :identification.type/passport
    :value :identification.type/passport
    :label {:en "Passport"
            :fi "Passi"}}
   {:key :identification.type/id-card
    :value :identification.type/id-card
    :label {:en "National ID card (both sides of the card)"
            :fi "Virallinen henkilökortti"}}])

(def type-of-identification-attachment
  {:field :person/type-of-identification-attachment
   :label {:en "Identification type"}
   :data-type :data.type/keyword
   :options identification-options
   :linked-fields [:person/passport-photo-page-file
                   :person/id-card-front-file
                   :person/id-card-back-file]})

(def identification-expiration-date
  {:field :person/identification-expiration-date
   :label {:en "Identification expiration date"}
   :data-type :data.type/date})

(def identification-attachment
  {:field :person/identification-attachment
   :label {:en "Upload certified copy of valid identification"}
   :data-type :data.type/file})

(def passport-photo-page-file
  {:field :person/passport-photo-page-file
   :label {:en "Passport photo page"}
   :data-type :data.type/file
   :mandatoriness :mandatory/when-visible})

(def id-card-front-file
  {:field :person/id-card-front-file
   :label {:en "ID card - front side"}
   :data-type :data.type/file
   :mandatoriness :mandatory/when-visible})

(def id-card-back-file
  {:field :person/id-card-back-file
   :label {:en "ID card - back side"}
   :data-type :data.type/file
   :mandatoriness :mandatory/when-visible})

(def proof-of-address-attachment
  {:field :person/proof-of-address-attachment
   :label {:en "Proof of address (e.g. utility bill or similar)"}
   :data-type :data.type/file})

(def source-of-funds-and-wealth
  {:field :person/source-of-funds-and-wealth
   :label {:en "Source of funds and wealth"}
   :data-type :data.type/text-multiline})
